<template>
	<v-card flat class="pa-2">
		<v-card-title class="text-body-1 font-weight-bold">
			My Projects
		</v-card-title>

		<v-data-table
			:headers="headers"
			:items="projects"
			item-key="uuid"
			density="comfortable"
			:items-per-page="-1"
			hide-default-footer
		>
			<template #[`item.name`]="{ item }">
				<v-icon v-if="item.isUrgent" size="small" color="error" class="mr-1">
					mdi-alarm
				</v-icon>
				<a
					class="text-primary font-weight-medium project-link"
					role="button"
					tabindex="0"
					@click="$emit('open-project', item.uuid)"
					@keyup.enter="$emit('open-project', item.uuid)"
				>
					{{ item.name }}
				</a>
				<project-paper-match :item="item" />
			</template>

			<template #[`item.assigned`]="{ item }">
				{{ item.counts.assigned }}
			</template>
			<template #[`item.inProgress`]="{ item }">
				{{ item.counts.inProgress }}
			</template>
			<template #[`item.completed`]="{ item }">
				{{ item.counts.completed }}
			</template>
			<template #[`item.completedAll`]="{ item }">
				{{ item.counts.completedAll }}
			</template>

			<template #[`item.assignedUserCount`]="{ item }">
				<v-chip
					v-if="item.assignedUserCount > 0"
					size="small"
					variant="flat"
					class="bg-provenance-b-tint text-provenance-b-ink"
					prepend-icon="mdi-account-multiple-outline"
				>
					{{ item.assignedUserCount }}
					<v-tooltip activator="parent" location="top">
						<div
							v-for="user in item.assignedUsers"
							:key="user.uuid"
						>
							{{ userLabel(user) }}
						</div>
					</v-tooltip>
				</v-chip>
				<span v-else class="text-grey-darken-2">0</span>
			</template>

			<template #no-data>
				<div class="text-grey-darken-2 pa-4">
					You are not a member of any projects yet.
				</div>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import ProjectPaperMatch from "@/components/ProjectPaperMatch.vue";

export default {
	name: "MyProjectsTable",

	components: {
		ProjectPaperMatch,
	},

	props: {
		// Already scoped + (when searching) filtered by the parent's server
		// fetch of /projects/mine; rendered as-is so paper-matched projects
		// whose NAME doesn't contain the term aren't hidden by a client filter.
		projects: {
			type: Array,
			default: () => [],
		},
	},

	emits: ["open-project"],

	data() {
		return {
			headers: [
				{ title: "Priority", key: "priority", align: "center", width: 80 },
				{ title: "Project", key: "name" },
				{
					title: "Assigned to Me",
					key: "assigned",
					align: "center",
					sortable: false,
				},
				{
					title: "In Progress",
					key: "inProgress",
					align: "center",
					sortable: false,
				},
				{
					title: "Completed",
					key: "completed",
					align: "center",
					sortable: false,
				},
				{
					title: "Completed (All)",
					key: "completedAll",
					align: "center",
					sortable: false,
				},
				{
					title: "Assigned Users",
					key: "assignedUserCount",
					align: "center",
					sortable: false,
				},
			],
		};
	},

	methods: {
		// DCTL-2124: label for the assigned-user hover tooltip; email fallback
		// (matches Dashboard.vue / ProjectView).
		userLabel(user) {
			const name = `${user.firstName || ""} ${user.lastName || ""}`.trim();
			return name || user.email || "";
		},
	},
};
</script>

<style scoped lang="scss">
.project-link {
	cursor: pointer;
	text-decoration: underline;
}
</style>
